export const SET_ACTIVETAB = '@customization/SET_ACTIVETAB';